<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item ><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">商品管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>商品分类</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="所属行业">
				<el-select v-model="item.industry_id" clearable placeholder="请选择" size="small">
					<el-option v-for="(option, index) in options" :key="option.id" :label="option.name" :value="option.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="分类名称">
				<el-input v-model="item.name" placeholder="请输入分类名称" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['admin/productCategory/add']">添加分类</el-button>
			<el-button type="danger" size="small" @click="delAll" v-auth="['admin/productCategory/delete']">批量删除</el-button>
		</div>


		<el-table ref="table" :data="list" border stripe highlight-current-row
		@selection-change="handleSelectionChange" row-key="id" lazy
			:load="load" :tree-props="{children: 'children', hasChildren: 'children_count'}">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column prop="name" label="分类名称"></el-table-column>
			<el-table-column prop="parent_idName" label="上级分类">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.parent">
						{{scope.row.parent.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="分类图标">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.logo" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="level" label="所在层级" align="center" width="100"></el-table-column>
			<el-table-column prop="orders" label="排序号" align="center" width="100"></el-table-column>
			<el-table-column  label="所属行业" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.industry">
						{{scope.row.industry.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>

			<el-table-column label="操作" width="160" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/productCategory/update']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row)" class="l10" v-auth="['admin/productCategory/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,

				// 查询
				item: {},
				number: 0,
				options: [],
				loadItem: []
			}
		},
		created() {
			this.loadList()
			this.getIndustry()
		},
		methods: {
			gotopage(url){
				console.log(url);
				var link =  this.$router.resolve({
				    path: url,
					query: {
						page: this.item.page
					}
				});
				window.open(link.href, '_blank')
			},
			getIndustry() {
				this.axios.post('/admin/industry/list', {
				}).then(res => {
					this.options = res.data.list
				})
			},
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/admin/productCategory/listTreeByPid', {
					industry_id: this.item.industry_id,
					name: this.item.name
				})
				.then(res => {
					this.isLoad = !this.isLoad
					// 获取数据
					this.list = res.data.list.data
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			load(tree, treeNode, resolve) {
				//1415567502557691905
				this.loadItem = []
				this.axios.post('/admin/productCategory/listTreeByPid', {
					parent_id: tree.id
				})
				.then(res => {
					// 获取数据
					this.list1 = res.data.list.data
					console.log(this.list1)
					this.loadItem = this.list1
					// 页数 page
					// this.total = res.data.total
					resolve(this.loadItem)

				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/Category/edit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Category/edit.html',
					query: {
						id: id
					}
				});
			},
			//
			del(scope) {
				let id = scope.id
				let parent_ids = scope.parent_id
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/productCategory/delete', {
						data: {
							ids: id
						}
					})
					.then((res) => {
						this.isLoad = !this.isLoad
						if (parent_ids != 0) {
							let parent_ids = scope.parent_id
							let arrRefs = this.$refs.table.store.states.lazyTreeNodeMap
							let arrParent = arrRefs[parent_ids]
							let indexs = -1
							arrParent.forEach((key, index) => {
								if (id === key.id) {
									indexs = index
								}
							})
							arrParent.splice(indexs, 1);
						}

						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAll() {
				let id = []
				let parent_ids = []
				let arrRefs = this.$refs.table.store.states.lazyTreeNodeMap
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					parent_ids.push(item.parent_id)
					id.push(item.id)
				}
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/productCategory/delete', {
						data: {
							ids: id
						}
					}).then(() => {
						this.isLoad = !this.isLoad

						// 删除数组中的值
						parent_ids.forEach((key,index) => {
							let arrParent = arrRefs[key]
							if(arrParent){
								arrParent.forEach((key, index) => {
									if(id.indexOf(key.id) != -1){
										arrParent.splice(index, 1);
									}
								})
							}

						})

						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			sizeReload(val) {
				this.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.item.page = 1
				this.loadList()
			},
		}
	}
</script>
<style scoped>
</style>
